import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
  container: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  content: {
    flex: 1
  },
}));

export default useStyles;
